var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"outlined":""}},[(_vm.showHeader)?_c('div',{staticClass:"header-title primary pt-4 pb-4 text-center"},[_vm._v(" "+_vm._s(_vm.headerTitle)+" ")]):_vm._e(),_c('div',{staticClass:"pa-6",class:{
      'pl-0': _vm.removePadLeft,
      'pt-0': _vm.removePadTop,
      'pr-0': _vm.removePadRight,
      'pb-0': _vm.removePadBottom
    }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }